export default "__VITE_ASSET__ChPHHCb3__"